import { Component, OnInit, inject} from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  passwordStrengthValidator,
  passwordsMatchValidator
} from '@core/shared/form-validators';
import {AuthService} from '@services/api/auth/auth.service';
import { Subject, takeUntil } from 'rxjs';
import {SharedDataService} from '@services/share-data/share-data.service';
import {MaterialModule} from '@app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { environment } from '@environment/environment';

@Component({
  selector: 'app-recovery-password-reset',
  imports: [ReactiveFormsModule, MaterialModule, CommonModule, TranslateModule, TablerIconsModule],
  templateUrl: './recovery-password-reset.component.html',
  standalone: true,
  styleUrl: './recovery-password-reset.component.scss'
})
export class RecoveryPasswordResetComponent implements OnInit {
  recovery_password_reset:FormGroup;
  protected readonly passwordMinLength = environment.password_min_length;
  hideNewPassword = true;
  hideConfirmPassword = true;
  private router = inject(Router);
  private destroy$ = new Subject<void>();
  private auth_service = inject(AuthService);
  private uidb64: string = '';
  private token: string = '';
  private route = inject(ActivatedRoute);
  private share_data_service = inject(SharedDataService);

  constructor(private fb: FormBuilder) {
    this.recovery_password_reset = this.fb.group({
      new_password1: ['', [Validators.required, Validators.minLength(this.passwordMinLength), passwordStrengthValidator()]],
      new_password2: ['', Validators.required],
    }, { validators: passwordsMatchValidator('new_password1', 'new_password2')
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.uidb64 = params['uidb64'];
      this.token = params['token'];
    });
  }

  onSubmit(): void {
      if (this.recovery_password_reset.valid) {
        this.auth_service
          .reset_password(
            this.recovery_password_reset.get('new_password1')?.value,
            this.recovery_password_reset.get('new_password2')?.value,
            this.uidb64,
            this.token
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response) => {
              const email = this.recovery_password_reset.get('email')?.value;
              this.share_data_service.setData(email);
              this.router.navigate(['recovery-password-done']);
            },
            error: (error) => {
              this.recovery_password_reset.reset();
            }
          });
      }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get password1FormControl() {
    return this.recovery_password_reset.get('new_password1');
  }
  get password2FormControl() {
    return this.recovery_password_reset.get('new_password2');
  }

  goBack(): void {
    this.router.navigate(['recovery-password']);
  }
}
